import React, { useEffect, useState } from "react";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { msalInitialized, pca, signalMsalReady } from "./msal";
const DEBUG_PREFIX = "[AUTH-PROVIDER]";
/**
 * Inner component that runs inside MsalProvider.
 * Waits for inProgress === "none" (meaning redirect is processed),
 * then signals msalReady so the API layer can acquire tokens.
 */
function MsalReadyGate({ children }) {
    const { accounts, inProgress } = useMsal();
    const [ready, setReady] = useState(false);
    useEffect(() => {
        if (inProgress === "none") {
            signalMsalReady();
            setReady(true);
        }
    }, [inProgress, accounts]);
    if (!ready) {
        return (React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
            } },
            React.createElement("span", null, "Signing in\u2026")));
    }
    return React.createElement(React.Fragment, null, children);
}
export default function AuthProvider({ children }) {
    const [initialized, setInitialized] = useState(false);
    useEffect(() => {
        msalInitialized
            .then(() => {
            setInitialized(true);
        })
            .catch((err) => {
            console.error(DEBUG_PREFIX, "PCA initialization FAILED:", err);
            setInitialized(true); // still render so user sees login page
        });
    }, []);
    if (!initialized) {
        return (React.createElement("div", { style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
            } },
            React.createElement("span", null, "Initializing\u2026")));
    }
    return (React.createElement(MsalProvider, { instance: pca },
        React.createElement(MsalReadyGate, null, children)));
}
